import { action, makeObservable, observable, runInAction } from 'mobx'
import { NavigateFunction } from 'react-router-dom'
import { ISelectOption } from 'src/Models/Client'
import IGenericError from 'src/Models/Server/IGenericError'
import { ToSelectOptions } from 'src/Models/Server/INameIdVTO'
import IInsertTerminalRequest from 'src/Models/Server/Request/Terminal/IInsertTerminalRequest'
import IPosVTO from 'src/Models/Server/Response/Pos/IPosVTO'
import PosController from 'src/Services/ToprCoreApi/Axios/Controllers/PosController'
import TerminalController from 'src/Services/ToprCoreApi/Axios/Controllers/TerminalController'
import { appUiStore } from 'src/Stores/AppUiStore'
import BaseStore from 'src/Stores/BaseStore'

export interface IFormValues extends IInsertTerminalRequest {
  SelectedTerminalType: ISelectOption
}

export default class Store extends BaseStore<IFormValues> {
  public Pos: IPosVTO = undefined
  public TerminalTypes: ISelectOption[] = []

  constructor() {
    super()
    makeObservable(this, {
      Pos: observable,
      TerminalTypes: observable,
      Initialize: action,
      Insert: action,
    })
  }

  public Initialize(posGuid: string, posName: string) {
    this.BaseInitialize({
      PosGuid: posGuid,
      Description: posName,
      TerminalTypeID: '-1',
      SelectedTerminalType: null,
    })

    this.IsLoading = true

    Promise.all([
      PosController.GetPos(posGuid),
      TerminalController.GetTerminalTypes(),
    ])
      .then((values) => {
        runInAction(() => {
          this.Pos = values[0]
          this.TerminalTypes = ToSelectOptions(values[1])
          this.IsLoading = false
        })
      })
      .catch((error: IGenericError) => {
        runInAction(() => (this.IsLoading = false))
        appUiStore.ShowError(error)
      })
  }

  public Insert(
    posGuid: string,
    terminalTypeId: string,
    description: string,
    navigate: NavigateFunction
  ) {
    this.IsSubmitting = true
    const data: IInsertTerminalRequest = {
      Description: description,
      PosGuid: posGuid,
      TerminalTypeID: terminalTypeId,
    }
    TerminalController.Insert(data)
      .then((terminalId) => {
        runInAction(() => (this.IsSubmitting = false))
        navigate(`/terminal/details/${terminalId}`)
      })
      .catch((error: IGenericError) => {
        runInAction(() => (this.IsSubmitting = false))
        appUiStore.ShowError(error)
      })
  }
}

export const insertTerminalStore = new Store()
